import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Box from '@firsttable/web-components/atoms/Box';

const LazyLoadImageWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;

  &::after,
  &::before {
    content: '';
    position: absolute;
    background: ${themeGet('colors.grayscale.300')};
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  &::after {
    opacity: 0;
  }
  &.loading {
    ::before,
    ::after {
      opacity: 1;
    }
    ::before {
      animation: bgPulse 1s ease-out infinite;
    }
  }
  span {
    height: 100% !important;
  }
  img {
    object-fit: cover;
    background: white;
  }
`;

export { LazyLoadImageWrapper as default };
